import _ from 'underscore';
import $ from 'jquery';

export default class UserProductMassSpecs {
  constructor($scope, UserProductService) {
    $scope.tabs = ['Selected Products', 'Add Reels Specs', 'Add Sheets Specs'];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.add_mass_specs = function() {
      var products = _.filter($scope.products_without_specs, function(p) {
        return p.checked == true;
      });
      if (products.length == 0) {
        alert('Please select at least one product!');
      } else {
        $scope.adding_mass_specs = true;
        UserProductService.save_mass_specs(_.pluck(products, 'id'), $scope.specs).then(function() {
          $scope.adding_mass_specs = false;
          $.fancybox.close();
          $scope.$parent.load_user_products();
        });
      }
    };

    $scope.get_specs = function() {
      $scope.specs = [];
      $scope.add_spec(true, 1, true, 0);
      $scope.add_spec(true, 1, false, {
        from: 0,
        to: 0
      });
      $scope.add_spec(true, 2, true, 0);
      $scope.add_spec(true, 2, false, {
        from: 0,
        to: 0
      });
      $scope.add_spec(true, 3, false, {
        from: 0,
        to: 0
      });
      $scope.add_spec(true, 4, false, {
        from: 0,
        to: 0
      });
      $scope.add_spec(false, 1, true, 0);
      $scope.add_spec(false, 1, false, {
        from: 0,
        to: 0
      });
      $scope.add_spec(false, 5, false, {
        from: 0,
        to: 0
      });
    };

    $scope.add_spec = function(is_reels, spec_type, is_accurate, value) {
      var spec = {
        is_reels: is_reels,
        spec_type: spec_type,
        is_accurate: is_accurate,
        value: value
      };
      if (spec_type == 1 && is_accurate)
        spec['combinations'] = [];
      $scope.specs.push(spec);
    };

    $scope.update_combinations = function(substance, spec) {
      var index = substance.combinations.indexOf(spec);
      if (index > -1)
        substance.combinations.splice(index, 1);
      else
        substance.combinations.push(spec);
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.get_specs();
    };

    $scope.init();
  }
}

UserProductMassSpecs.$inject = ['$scope', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-mass-specs.ctrl.js